<div class="notes-container">
  <div class="notes-header">
    <div class="title-container">
      <h3 class="section-title">{{ title() }}</h3>
      @if (lastUpdatedInfo) {
        <span class="last-updated-info">{{ lastUpdatedInfo }}</span>
      }
    </div>
    @if (!isReadOnly() && !isLoading) {
      <div class="header-actions">
        @if (isEditMode) {
          @if (isSaving) {
            <mat-spinner diameter="18"></mat-spinner>
          } @else {
            <mat-icon
              class="header-icon"
              matTooltip="Cancel"
              matTooltipPosition="below"
              (click)="cancelEdit()"
            >close</mat-icon>
            <mat-icon
              class="header-icon save-icon"
              matTooltip="Save"
              matTooltipPosition="below"
              (click)="saveNote()"
            >check</mat-icon>
          }
        } @else {
          <mat-icon
            class="header-icon"
            matTooltip="Edit notes"
            matTooltipPosition="below"
            (click)="toggleEditMode()"
          >edit</mat-icon>
        }
      </div>
    }
  </div>

  <div class="notes-content">
    @if (isLoading) {
      <div class="loading-state">
        <mat-spinner diameter="24"></mat-spinner>
        <span>Loading notes...</span>
      </div>
    } @else if (error) {
      <div class="error-state">
        <mat-icon>error_outline</mat-icon>
        <span>{{ error }}</span>
      </div>
    } @else {
      <!-- Formatting Toolbar - always in DOM for smooth transitions -->
      <div class="toolbar-wrapper" [class.visible]="isEditMode">
        <div class="formatting-toolbar">
          <button
            mat-icon-button
            matTooltip="Bold"
            (click)="formatBold()"
            class="format-button"
            [class.active]="isBoldActive"
            disableRipple
          >
            <mat-icon>format_bold</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Italic"
            (click)="formatItalic()"
            class="format-button"
            [class.active]="isItalicActive"
            disableRipple
          >
            <mat-icon>format_italic</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Underline"
            (click)="formatUnderline()"
            class="format-button"
            [class.active]="isUnderlineActive"
            disableRipple
          >
            <mat-icon>format_underlined</mat-icon>
          </button>
          <span class="toolbar-divider"></span>
          <button
            mat-icon-button
            matTooltip="Bullet list"
            (click)="formatBulletList()"
            class="format-button"
            [class.active]="isBulletListActive"
            disableRipple
          >
            <mat-icon>format_list_bulleted</mat-icon>
          </button>
          <button
            mat-icon-button
            matTooltip="Numbered list"
            (click)="formatNumberedList()"
            class="format-button"
            [class.active]="isNumberedListActive"
            disableRipple
          >
            <mat-icon>format_list_numbered</mat-icon>
          </button>
          <span class="toolbar-divider"></span>
          <button
            mat-icon-button
            matTooltip="Clear formatting"
            (click)="clearFormatting()"
            class="format-button"
            disableRipple
          >
            <mat-icon>format_clear</mat-icon>
          </button>
        </div>
      </div>

      @if (isEditMode) {
        <!-- Editable Content Area -->
        <div class="editor-container">
          <div
            #editor
            class="notes-editor"
            contenteditable="true"
            [innerHTML]="editorInitialContent"
            (input)="onContentChange()"
            (paste)="onPaste($event)"
            (mousedown)="onEditorMouseDown($event)"
            (click)="onEditorClick($event)"
            (mouseup)="onSelectionChange()"
            (keyup)="onSelectionChange()"
            (keydown)="onEditorKeyDown($event)"
            [attr.data-placeholder]="placeholder()"
          ></div>

          <!-- Mention Dropdown -->
          @if (showMentionDropdown) {
            <div 
              class="mention-dropdown"
              [style.top.px]="dropdownPosition.top"
              [style.left.px]="dropdownPosition.left"
            >
              @if (isSearchingMentions) {
                <div class="mention-loading">
                  <mat-spinner diameter="16"></mat-spinner>
                  <span>Searching...</span>
                </div>
              } @else if (mentionSuggestions.length === 0) {
                <div class="mention-empty">
                  @if (mentionSearchTerm.length === 0) {
                    <span>Type to search resources...</span>
                  } @else {
                    <span>No resources found</span>
                  }
                </div>
              } @else {
                @for (suggestion of mentionSuggestions; track suggestion.employeeId; let i = $index) {
                  <div 
                    class="mention-item"
                    [class.selected]="i === selectedMentionIndex"
                    (click)="selectMention(suggestion)"
                    (mouseenter)="selectedMentionIndex = i"
                  >
                    <span class="mention-name">{{ suggestion.fullName }}</span>
                    @if (suggestion.title) {
                      <span class="mention-title">{{ suggestion.title }}</span>
                    }
                  </div>
                }
              }
            </div>
          }
        </div>
      } @else {
        <!-- View Mode -->
        @if (hasContent) {
          <div class="notes-view" [innerHTML]="displayContent" (click)="onNotesViewClick($event)"></div>
        } @else {
          <div class="empty-state">
            <mat-icon>notes</mat-icon>
            <p>{{ placeholder() }}</p>
          </div>
        }
      }
    }
  </div>
</div>
